var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLifestyleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21198",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bold/Heart"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Heart",
    d: "M12.027 19.2l-.207-.128a30.531 30.531 0 01-5.1-3.969 10.394 10.394 0 01-2.405-3.839 6.2 6.2 0 01.114-4.22A4.867 4.867 0 017.46 4.215a3.6 3.6 0 01.712-.167h.1A4.563 4.563 0 018.94 4h.088a5.013 5.013 0 011.464.264h.048a.265.265 0 01.072.048 2.7 2.7 0 01.5.209l.3.135a2.1 2.1 0 01.228.152c.046.033.085.062.116.081l.045.019a1.948 1.948 0 01.2.132A4.979 4.979 0 0115.048 4h.035a4.661 4.661 0 011.488.233 4.815 4.815 0 013 2.814 6.332 6.332 0 01.13 4.217 10.225 10.225 0 01-2.407 3.848 30.881 30.881 0 01-5.067 3.968l-.2.12zm3.926-12.706a.647.647 0 00-.605.434.656.656 0 00.4.823 1.341 1.341 0 01.853 1.257v.024a.688.688 0 00.152.5.672.672 0 00.456.232.658.658 0 00.632-.608v-.1a2.641 2.641 0 00-1.688-2.529.624.624 0 00-.2-.033z"
  }))));
}
export default SvgLifestyleIcon;